import Resource from '@/services/resource';
import client from './axiosClient';

export default new Resource(client, 'shared-cases', {
  unShareCase({ caseId, userId }) {
    const url = `/${this.base}/${caseId}/${userId}/`;
    return this.client.delete(url);
  },
});
